import { Navbar, Container, Nav, NavbarBrand } from "react-bootstrap";

const NavigationBar = () => {
  return (
    <Navbar variant="dark" className="sticky-navbar">
      <Container>
        <NavbarBrand href="/">NONTON ANIME</NavbarBrand>
        <Nav>
          <Nav.Link href="#Trending">TRENDING</Nav.Link>
          <Nav.Link href="#Superhero">ANIME</Nav.Link>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
